import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import CTABand from "@/components/CTABand";
import { TechLabel } from "@/components/Bits";
import usePageMeta from "@/hooks/usePageMeta";
import { CATALOG } from "@/config/company";

export default function Lavori() {
  usePageMeta(
    "Lavori realizzati — MMC S.r.l. | Carpenteria Metallica",
    "Il catalogo dei lavori realizzati da MMC S.r.l.: scale, rampe, tettoie, passerelle e strutture in acciaio. Fotografie reali divise per tipologia."
  );

  const total = CATALOG.reduce((n, c) => n + c.items.length, 0);

  return (
    <main>
      <PageHeader
        index="04"
        eyebrow="Catalogo"
        title="Lavori realizzati"
        sub="Il nostro catalogo, suddiviso per tipologia: fotografie reali di opere e interventi completati dall'officina MMC."
      />

      <section data-testid="catalogo" className="px-5 py-16 md:px-10 md:py-24 lg:px-16">
        <div className="mx-auto max-w-7xl">
          <TechLabel className="text-molten">
            {String(total).padStart(2, "0")} lavori — catalogo in costante aggiornamento
          </TechLabel>

          {CATALOG.map((cat, ci) => (
            <div key={cat.id} data-testid={`catalogo-sezione-${cat.id}`} className="mt-16 first:mt-12">
              <div className="flex items-baseline justify-between gap-4 border-b border-white/10 pb-4">
                <h2 className="font-display text-3xl font-semibold uppercase tracking-tight">
                  <span className="mr-3 font-tech text-sm font-normal text-molten">0{ci + 1}</span>
                  {cat.title}
                </h2>
                <TechLabel>{String(cat.items.length).padStart(2, "0")} lavori</TechLabel>
              </div>
              <div
                className={`mt-8 grid gap-6 ${
                  cat.items.length === 1
                    ? "grid-cols-1"
                    : cat.items.length === 2
                      ? "sm:grid-cols-2"
                      : "sm:grid-cols-2 lg:grid-cols-3"
                }`}
              >
                {cat.items.map((item, i) => (
                  <Reveal key={item.id} delay={(i % 3) * 0.08}>
                    <figure data-testid={`catalogo-item-${item.id}`} className="group">
                      <div className="relative h-[300px] overflow-hidden border border-white/10 md:h-[380px]">
                        <img
                          src={item.img}
                          alt={item.title}
                          loading="lazy"
                          className="h-full w-full object-cover grayscale transition-[filter,transform] duration-500 group-hover:scale-105 group-hover:grayscale-0"
                        />
                        <span className="absolute left-3 top-3 bg-ink/70 px-2 py-1 font-tech text-[9px] tracking-[0.25em] text-white/85 backdrop-blur">
                          {item.id}
                        </span>
                      </div>
                      <figcaption className="mt-3 text-sm text-white/75 transition-colors duration-300 group-hover:text-molten">
                        {item.title}
                      </figcaption>
                    </figure>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </main>
  );
}
